import { fetch, buildQueryString } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

export default {
  async search(userId, store, params) {
    const queryString = buildQueryString(params);

    return fetch(getUrl(`/${store}/products${queryString}`), {
      headers: {
        'Tgb-Owner': userId,
      },
    });
  },
};
